import React, { useState } from 'react';

const AuthModal = ({ isOpen, onClose, mode = 'login' }) => {
  const [currentMode, setCurrentMode] = useState(mode);
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    email: ''
  });

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50">
      <div 
        className="rounded-2xl p-6 w-96"
        style={{ 
          background: 'linear-gradient(145deg, #1a1a2e, #16213e)',
          border: '2px solid rgba(255,215,0,0.3)',
          boxShadow: '0 0 50px rgba(255,215,0,0.2)'
        }}
      >
        {/* Logo */}
        <div className="text-center mb-6">
          <div className="text-5xl mb-2">🎰</div>
          <h2 
            className="text-xl font-bold"
            style={{
              background: 'linear-gradient(180deg, #ffd700, #ff8c00)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}
          >
            {currentMode === 'login' ? 'WELCOME BACK' : 
             currentMode === 'signup' ? 'JOIN THE TABLE' : 'RECOVER ACCOUNT'}
          </h2>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          {currentMode !== 'forgot' && (
            <div>
              <label className="block text-xs font-bold mb-2 tracking-wider" style={{ color: '#888' }}>
                USERNAME
              </label>
              <input
                type="text"
                value={formData.username}
                onChange={(e) => setFormData({...formData, username: e.target.value})}
                className="w-full px-4 py-3 rounded-xl font-medium"
                style={{
                  background: 'rgba(0,0,0,0.3)',
                  border: '2px solid rgba(255,215,0,0.2)',
                  color: '#fff',
                  outline: 'none'
                }}
                placeholder="Enter username"
              />
            </div>
          )}

          {currentMode === 'forgot' && (
            <div>
              <label className="block text-xs font-bold mb-2 tracking-wider" style={{ color: '#888' }}>
                EMAIL OR USERNAME
              </label>
              <input
                type="text"
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                className="w-full px-4 py-3 rounded-xl font-medium"
                style={{
                  background: 'rgba(0,0,0,0.3)',
                  border: '2px solid rgba(255,215,0,0.2)',
                  color: '#fff',
                  outline: 'none'
                }}
                placeholder="Enter email or username"
              />
            </div>
          )}

          {currentMode !== 'forgot' && (
            <div>
              <label className="block text-xs font-bold mb-2 tracking-wider" style={{ color: '#888' }}>
                PASSWORD
              </label>
              <input
                type="password"
                value={formData.password}
                onChange={(e) => setFormData({...formData, password: e.target.value})}
                className="w-full px-4 py-3 rounded-xl font-medium"
                style={{
                  background: 'rgba(0,0,0,0.3)',
                  border: '2px solid rgba(255,215,0,0.2)',
                  color: '#fff',
                  outline: 'none'
                }}
                placeholder="Enter password"
              />
            </div>
          )}

          {currentMode === 'login' && (
            <button
              type="button"
              onClick={() => setCurrentMode('forgot')}
              className="text-sm hover:underline"
              style={{ color: '#ffd700' }}
            >
              Forgot Password?
            </button>
          )}

          <button
            type="submit"
            className="w-full py-4 rounded-xl font-bold text-lg transition-all hover:scale-105"
            style={{
              background: 'linear-gradient(145deg, #ffd700, #b8860b)',
              color: '#1a1a2e',
              boxShadow: '0 4px 20px rgba(255,215,0,0.3)'
            }}
          >
            {currentMode === 'login' ? '🎲 LOGIN' : 
             currentMode === 'signup' ? '🎰 SIGN UP' : '📧 SEND RESET LINK'}
          </button>

          <div className="text-center">
            {currentMode === 'login' && (
              <button
                type="button"
                onClick={() => setCurrentMode('signup')}
                className="text-sm hover:underline"
                style={{ color: '#888' }}
              >
                Don't have an account? <span style={{ color: '#ffd700' }}>Sign Up</span>
              </button>
            )}
            {currentMode === 'signup' && (
              <button
                type="button"
                onClick={() => setCurrentMode('login')}
                className="text-sm hover:underline"
                style={{ color: '#888' }}
              >
                Already have an account? <span style={{ color: '#ffd700' }}>Login</span>
              </button>
            )}
            {currentMode === 'forgot' && (
              <button
                type="button"
                onClick={() => setCurrentMode('login')}
                className="text-sm hover:underline"
                style={{ color: '#ffd700' }}
              >
                Back to Login
              </button>
            )}
          </div>
        </form>

        <button
          onClick={onClose}
          className="w-full mt-4 py-2 text-sm transition-all hover:scale-105"
          style={{ color: '#666' }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default AuthModal;
